'use client';
import { memo, useEffect, useRef } from 'react';

export const InjectScript = memo(function InjectScript({
  src,
}: {
  src: string;
}) {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = divRef.current;
    if (!node) return;

    const script = document.createElement('script');

    script.src = src;
    script.async = true;

    node.appendChild(script);

    return () => {
      node.removeChild(script);
    };
  }, [src]);

  return <div ref={divRef} />;
});
